module.exports = __webpack_public_path__ + "static/logo-d83ec260ee7e72c0218b4823da2ef56b.png";